import type { HelpFile } from '../../types/help'
import { SqlEditorTestIds } from '../../../testids/SqlEditorTestIds'

export const sqlEditorHelp: HelpFile = {
  docPage: '/docs/admin/sql-editor',
  texts: {
    [SqlEditorTestIds.sqlEditor]:
      'SQL-Abfrage gegen die reine Lese-Reporting-View formulieren. So lassen sich Form und Parameter prüfen, bevor die Reportdefinition gespeichert wird.',
    [SqlEditorTestIds.sqlEditorTextarea]:
      'SQL hier eintragen. Bind-Parameter werden über `:name`-Platzhalter angesprochen und auf die Parameterliste des Reports abgebildet.',
  },
}
